module.exports = __webpack_public_path__ + "static/media/news-cdphp-covid-rules.6767d690.jpg";